<div class="user-badge" *ngIf="isLoggedIn">
  <span *ngIf="loggedInName" class="user-badge-name">Innlogget som {{loggedInName}}<ng-container *ngIf="developerOrganizationName"> på vegne av {{developerOrganizationName}}</ng-container></span>
  <button class="btn btn-default" (click)="logOut()">Logg ut</button>
</div>
